var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { buildOgMeta } from '../types/builders';
import { TAG_TYPES } from '../types/TagTypes';
var WIX_DATA_PAGE_ITEM = 'wix-data-page-item';
export function resolveOgImageTagsWixData(tags, resolvedContext) {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k;
    if (!tags) {
        return tags;
    }
    var ogImageTag = tags.find(function (tag) { var _a; return tag.type === TAG_TYPES.META && ((_a = tag.props) === null || _a === void 0 ? void 0 : _a.property) === 'og:image'; });
    if (!((_c = (_b = (_a = ogImageTag === null || ogImageTag === void 0 ? void 0 : ogImageTag.props) === null || _a === void 0 ? void 0 : _a.content) === null || _b === void 0 ? void 0 : _b.includes) === null || _c === void 0 ? void 0 : _c.call(_b, '{{')) ||
        !((_f = (_e = (_d = ogImageTag === null || ogImageTag === void 0 ? void 0 : ogImageTag.props) === null || _d === void 0 ? void 0 : _d.content) === null || _e === void 0 ? void 0 : _e.includes) === null || _f === void 0 ? void 0 : _f.call(_e, WIX_DATA_PAGE_ITEM))) {
        return tags;
    }
    var collectionIdMatch = ogImageTag.props.content.match(new RegExp("".concat(WIX_DATA_PAGE_ITEM, "\\.([^.]+)\\.")));
    var collectionId = collectionIdMatch ? collectionIdMatch[1] : null;
    var propertyIdMatch = ogImageTag.props.content.match(new RegExp("".concat(WIX_DATA_PAGE_ITEM, "\\.").concat(collectionId, "\\.([^}\\s]+)")));
    var propertyId = propertyIdMatch ? propertyIdMatch[1] : null;
    var collection = (_h = (_g = resolvedContext === null || resolvedContext === void 0 ? void 0 : resolvedContext["".concat(WIX_DATA_PAGE_ITEM, ".collections")]) === null || _g === void 0 ? void 0 : _g.find) === null || _h === void 0 ? void 0 : _h.call(_g, function (_a) {
        var id = _a.id;
        return id === collectionId;
    });
    if (!collection) {
        return tags;
    }
    var property = (_k = (_j = collection.fields) === null || _j === void 0 ? void 0 : _j.find) === null || _k === void 0 ? void 0 : _k.call(_j, function (_a) {
        var key = _a.key;
        return key === propertyId;
    });
    if (!(property === null || property === void 0 ? void 0 : property.value)) {
        return tags;
    }
    var newTags = [];
    property.value.width &&
        newTags.push(buildOgMeta('og:image:width', "".concat(property.value.width)));
    property.value.height &&
        newTags.push(buildOgMeta('og:image:height', "".concat(property.value.height)));
    return __spreadArray(__spreadArray([], tags, true), newTags, true);
}
